import Vue from "vue"
import "./fb.pixel"
import App from "./App.vue"
import "./registerServiceWorker"

import router from "./router"
import store from "./store"
import './assets/styles/index.scss'
import Axios from 'axios'
import VueGtm from "vue-gtm";
import VueClipboard from 'vue-clipboard2';





const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);


Vue.config.productionTip = false
Vue.prototype.$http = Axios

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard)

Vue.use(VueGtm, {
  id: 'GTM-K42FL5F', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  debug: false, // Whether or not display console logs debugs (optional)
  enabled: process.env.NODE_ENV !== 'development',
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});


const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

/**
 *
 * @param unit - substract unit: minute, hour, day
 * @param value - substract value
 * @returns {Date} - new date
 */
Date.prototype.add = function (unit, value) {
  const date = new Date(this.valueOf());

  switch (unit) {
    case 'minute': {
      date.setDate(date.getMinutes() + value);
      break;
    }
    case 'hour': {
      date.setDate(date.getHours() + value);
      break;
    }
    case 'day': {
      date.setDate(date.getDate() + value);
      break;
    }
    default: {
      throw new Error('Please, provide correct unit');
    }
  }

  return date;
}

Date.prototype.toUTC = function () {
  const date = new Date(this.valueOf());
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

Date.prototype.fromUTC = function () {
  const date = new Date(this.valueOf())

  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();

  date.setHours(hours - offset);
  return date;
}

Date.prototype.isToday = function () {
  const today = new Date();
  return this.getDate() === today.getDate() &&
    this.getMonth() === today.getMonth() &&
    this.getFullYear() === today.getFullYear()
}

Date.prototype.isCurrentHour = function () {
  const now = new Date();
  return this.getDate() === now.getDate() &&
    this.getMonth() === now.getMonth() &&
    this.getFullYear() === now.getFullYear() &&
    this.getHours() && now.getHours()
}

/**
 * Substract value from date
 * @param unit - substract unit: minute, hour, day
 * @param value - substract value
 * @returns {Date} - new date
 */
Date.prototype.substract = function (unit, value) {
  const date = new Date(this.valueOf());

  switch (unit) {
    case 'minute': {
      date.setDate(date.getMinutes() - value);
      break;
    }
    case 'hour': {
      date.setDate(date.getHours() - value);
      break;
    }
    case 'day': {
      date.setDate(date.getDate() - value);
      break;
    }
    default: {
      throw new Error('Please, provide correct unit');
    }
  }

  return date;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
